<template>
	<div class="ap-detail">
		<div class="ap-head">
			<v-avatar v-if="provider.logo" size="20px" tile class="mr-1"><img :src="provider.logo" alt="" /></v-avatar>
			<v-icon v-else small class="mr-1">{{ provider.icona }}</v-icon>
			<span class="ap-head-title">Accesso con {{ provider.nome }}</span>
			<v-chip x-small label class="ml-1" :color="attivo ? 'success' : undefined" :outlined="!attivo">{{ attivo ? 'Attivo sul sito' : 'Spento' }}</v-chip>
			<span class="ap-muted ml-1">· {{ compilati }}/{{ provider.campi.length }} campi compilati</span>
		</div>

		<div class="ap-body">
			<!-- cosa fare nella console del provider -->
			<div class="ap-block">
				<div class="ap-section">1 · Sul sito di {{ provider.nome }}</div>
				<div class="ap-box ap-pad" :data-tour="primo ? 'callback' : undefined">
					<div class="ap-text">{{ provider.istruzioni }}</div>
					<div class="ap-url">
						<code>{{ provider.url }}</code>
						<v-btn x-small depressed color="primary" @click="copia(provider.url)">
							<v-icon left x-small>{{ copiato ? 'mdi-check' : 'mdi-content-copy' }}</v-icon
							>{{ copiato ? 'Copiato' : 'Copia' }}
						</v-btn>
					</div>
					<div v-if="provider.nota" class="ap-text ap-muted">{{ provider.nota }}</div>
					<v-btn v-if="provider.console" x-small outlined color="primary" class="mt-3" :href="provider.console" target="_blank" rel="noopener noreferrer">
						<v-icon left x-small>mdi-open-in-new</v-icon>Apri la console di {{ provider.nome }}
					</v-btn>
				</div>
			</div>

			<!-- credenziali da incollare qui -->
			<div class="ap-block">
				<div class="ap-section">2 · Credenziali</div>
				<div class="ap-box ap-pad">
					<div :data-tour="primo ? 'credentials' : undefined">
						<template v-for="campo in provider.campi">
							<v-textarea
								v-if="campo.textarea"
								:key="campo.key"
								v-model="provider.servizio.setting[campo.key]"
								:data-tour="campo.key === 'PrivateKey' ? 'apple-key' : undefined"
								:label="campo.label"
								:class="{ 'ap-masked': campo.segreto && !visibili[campo.key] }"
								:append-icon="campo.segreto ? (visibili[campo.key] ? 'mdi-eye-off-outline' : 'mdi-eye-outline') : undefined"
								rows="5"
								outlined
								dense
								hide-details
								class="mb-3"
								@click:append="mostra(campo.key)"
							></v-textarea>
							<v-text-field
								v-else
								:key="campo.key"
								v-model="provider.servizio.setting[campo.key]"
								:label="campo.label"
								:type="campo.segreto && !visibili[campo.key] ? 'password' : 'text'"
								:append-icon="campo.segreto ? (visibili[campo.key] ? 'mdi-eye-off-outline' : 'mdi-eye-outline') : undefined"
								autocomplete="off"
								outlined
								dense
								hide-details
								class="mb-3"
								@click:append="mostra(campo.key)"
							></v-text-field>
						</template>
					</div>
					<div class="d-flex align-center">
						<span class="ap-muted ap-small">L'interruttore nella riga accende o spegne {{ provider.nome }} sul sito.</span>
						<v-spacer></v-spacer>
						<v-btn v-if="provider.connessione" small outlined color="primary" class="mr-2" @click="$emit('verifica', provider.connessione)"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
						<v-btn depressed small color="primary" :data-tour="primo ? 'confirm' : undefined" @click="$emit('salva')"><v-icon left small>mdi-content-save-outline</v-icon>Salva</v-btn>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// configurazione di un provider di accesso social: indirizzo di ritorno da copiare nella sua console e credenziali
export default {
	name: 'AuthProviderDetail',
	props: {
		// voce di providerCard in Authentication.vue
		provider: { type: Object, required: true },
		// il primo provider porta i bersagli del tutorial
		primo: { type: Boolean, default: false },
	},
	data() {
		return { copiato: false, visibili: {} };
	},
	computed: {
		attivo() {
			return !!(this.provider.servizio && this.provider.servizio.active);
		},
		compilati() {
			const s = (this.provider.servizio && this.provider.servizio.setting) || {};
			return this.provider.campi.filter(c => String(s[c.key] || '').trim()).length;
		},
	},
	methods: {
		mostra(key) {
			this.$set(this.visibili, key, !this.visibili[key]);
		},
		async copia(testo) {
			try {
				await navigator.clipboard.writeText(testo);
			} catch (e) {
				// contesto non sicuro (http): ripiego con textarea
				const t = document.createElement('textarea');
				t.value = testo;
				document.body.appendChild(t);
				t.select();
				document.execCommand('copy');
				document.body.removeChild(t);
			}
			this.copiato = true;
			clearTimeout(this.timerCopia);
			this.timerCopia = setTimeout(() => (this.copiato = false), 1500);
		},
	},
	beforeDestroy() {
		clearTimeout(this.timerCopia);
	},
};
</script>

<style scoped>
.ap-detail {
	width: 100%;
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 10px;
	overflow: hidden;
	background: #f3f6fa;
	white-space: normal;
}
.ap-head {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
	padding: 8px 12px;
	background: #fff;
	border-bottom: 1px solid #e1e7ef;
	font-size: 13px;
}
.ap-head-title {
	font-weight: 600;
	color: #1f2d3d;
}
.ap-body {
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
	gap: 16px;
	padding: 12px;
}
.ap-section {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.ap-muted {
	color: #5f6b7a;
}
.ap-small {
	font-size: 12px;
}
.ap-box {
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
}
.ap-pad {
	padding: 12px;
}
.ap-text {
	font-size: 14px;
	line-height: 1.5;
}
.ap-url {
	display: flex;
	align-items: center;
	gap: 8px;
	margin: 8px 0;
	padding: 6px 6px 6px 10px;
	border-radius: 6px;
	background: #f3f6fa;
	border: 1px dashed #c8d3e1;
}
.ap-url code {
	flex: 1 1 auto;
	min-width: 0;
	background: transparent;
	padding: 0;
	font-size: 13px;
	color: #1a4f9c;
	word-break: break-all;
}
/* textarea della chiave privata: nascosta come una password finché non si preme l'occhio */
.ap-masked ::v-deep textarea {
	-webkit-text-security: disc;
}

@media (max-width: 959px) {
	.ap-body {
		grid-template-columns: 1fr;
	}
}
@media (max-width: 768px) {
	.ap-body {
		padding: 8px;
	}
}
</style>
